import axios from 'axios';
import _createAuthRefreshInterceptor from 'axios-auth-refresh';

// CJS interop: esbuild may wrap module.exports under .default
const createAuthRefreshInterceptor = ((_createAuthRefreshInterceptor as any)
  .default ??
  _createAuthRefreshInterceptor) as typeof _createAuthRefreshInterceptor;

import { sgwUrl } from '~/constants/environment';

import AuthService from '~/services/auth.service';

import { currentLocale } from '~/utils/i18n';

const axiosInstance = axios.create();

if (AuthService.refreshTokens) {
  createAuthRefreshInterceptor(
    axiosInstance,
    AuthService.refreshTokens.bind(AuthService),
  );
}

axiosInstance.interceptors.request.use((request) => {
  request.headers['Accept-Language'] = currentLocale();

  // If the access or id token as already been set manually, don't overwrite it. This is the case in the ids flow. (see ids.service.js)
  if (request.headers.Authorization) {
    return request;
  }

  // All calls to SGW and thus id token have been deprecated due to issues with SGW. Only use if approved by Yannick.
  const token = request.url?.includes(sgwUrl)
    ? AuthService.getIdToken()
    : AuthService.getAccessToken();

  request.headers.Authorization = `Bearer ${token}`;

  return request;
});

export default axiosInstance;
